import { PortalkonfigurationDisplayModel } from '@/api/model-index';
import { AbstractControl, ValidationErrors, Validator } from "@angular/forms";

let that: BICValidator;

export class BICValidator implements Validator {

    constructor(protected portalKonfiguration: PortalkonfigurationDisplayModel) {
        that = this;
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (! control.value)
            return null;
            
        let result: ValidationErrors | null = null;
        if (that.portalKonfiguration?.ibanueberpruefung === true) {            
            if (control.value) {
                const bic = control.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
                const code = bic.match(/^[A-Z0-9]{4}[A-Z]{2}[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/);
                return (code && code.length > 0) ? null : { isBICValid: false };
            }
        }
        return result;
    }
}